import { create } from '@thoughtspot/logger';
import { TSToChartEvent } from '@thoughtspot/ts-chart-sdk';
import { sendMessage } from '../../../services/post-message-event-dispatcher';
const logger = create('ts-to-chart > event-callbacks > get-column-data');
export const getColumnData = (commonProps, eventProps) => {
    const { iFrameWindow: iframeRef, appUrl } = commonProps;
    return sendMessage(iframeRef, {
        eventType: TSToChartEvent.GetColumnData,
        payload: eventProps,
    }, appUrl)
        .then(res => {
        return { ...res.data, loading: false };
    })
        .catch(err => {
        logger.error('Error in getColumnData', err);
        throw err;
    });
};
//# sourceMappingURL=index.js.map